/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { toast } from "react-hot-toast"
import { GET_APPLICATION_STATUS } from "../pages/ApplicationStatus/graphql";
import { GET_APPLICATION_ID } from "../pages/NewEpccApplication/graphql";
import {GET_APPLICATION_CURRENT_STATUS} from '../pages/Options/graphql';
import {IS_CERTIFICATE_VALID} from '../pages/Options/graphql/checkUserHasValidCertificate'

const MODULE_NAME = "ApplicationStatusService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ApplicationStatusService {
    private static instance: ApplicationStatusService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ApplicationStatusService {
        if (!ApplicationStatusService.instance) {
            ApplicationStatusService.instance = new ApplicationStatusService(props);
        }
        return ApplicationStatusService.instance;
    }

    async getApplicationCurrentStatus( args : any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }
        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_CURRENT_STATUS,
                    variables:{applicationId:args?.applicationId},
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "Application Current Status: ", res?.data);
                if (res) {
                    return res?.data?.getApplicationCurrentStatus;
                }
            }
        } catch (err: any) {
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getApplicationDetail() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('ApplicationStatusService()::getApplicationStatus()-> entered here..');
        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_ID,
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "Application ID: ", res?.data);
                if (res) {
                    return res?.data?.getUserProfile
                }
            }
        } catch (err: any) {
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getApplicationStatus(args : any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        console.log('ApplicationStatusService()::getApplicationStatus()-> entered here..',args);
        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_STATUS,
                    variables:{
                        applicationId:args?.applicationId,
                        getApplicationCurrentStatusApplicationId2:args?.applicationId
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "Application Status: ", res?.data);
                if (res) {
                    return {
                        getApplicationProgressStatus : res?.data?.getApplicationProgressStatus,
                        getApplicationCurrentStatus : res?.data?.getApplicationCurrentStatus,
                    }
                }
            }
        } catch (err: any) {
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getIsCertifcateValid() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }
        console.log('ApplicationStatusService()::getIsCertificateValid()-> entered here..');
        try {
            if (client) {
                const res = await client.query({
                    query: IS_CERTIFICATE_VALID,
                    // variables:{applicationId:'1653374522360'},
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "Application Valid Status: ", res?.data);
                if (res) {
                    return res?.data?.checkUserHasValidCertificate;
                }
            }
        } catch (err: any) {
            // err?.graphQLErrors &&
            //     Array.isArray(err?.graphQLErrors) &&
            //     err?.graphQLErrors.length > 0 &&
            //     toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
